import React from "react";
import { NumberDecrementStepper, NumberIncrementStepper, NumberInput as Input, NumberInputField, NumberInputStepper, } from "@chakra-ui/react";
export const NumberInput = (props) => {
    return (React.createElement(Input, Object.assign({ size: "sm", min: 0, max: 100 }, props),
        React.createElement(NumberInputField, null),
        React.createElement(NumberInputStepper, null,
            React.createElement(NumberIncrementStepper, null),
            React.createElement(NumberDecrementStepper, null))));
};
